export default __webpack_public_path__ + "fonts/poppins-latin-500-normal.08491d3f7fe7ae88ef44.woff2";